module.exports = __webpack_public_path__ + "img/3.bdb4001d.jpg";